<!--
 * @FileDescription: 新增成员对话框
 * @Author: 陈文景
 * @Date: 2022-09-22 14:32:37
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="添加成员" append-to-body :visible.sync="visible" width="50%" :before-close="close">
    <div class="member-container">
      <!-- 成员列表 -->
      <div class="member-list">
        <el-input v-model="query.email" clearable size="medium" placeholder="根据邮箱/手机号搜索成员">
          <el-button slot="append" icon="el-icon-search" @click="getUserOptions" />
        </el-input>
        <div class="member-item">
          <el-checkbox-group v-model="selectedMember">
            <el-checkbox v-for="member in memberList" :key="member" :label="member" />
          </el-checkbox-group>
        </div>
      </div>

      <!-- 已选择的成员 -->
      <div class="selected-member">
        <div class="selected-tips">
          已选 <span class="">{{ selectedMember.length }}</span> 人
        </div>
        <div class="selected-member-item">
          <el-tag v-for="member in selectedMember" :key="member" closable effect="plain" @close="() => closeMemberTag(member)">{{ member }}</el-tag>
        </div>
      </div>
    </div>

    <template slot="footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button size="medium" type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from '@/api'

let parameter = {
  roleId: undefined, // 角色ID
  userIds: [] // 用户ID
}

let query = {
  email: undefined, // 搜索关键字
  pageNumber: 1,
  pageSize: 20
}

export default {
  data() {
    return {
      visible: false, // 控制对话框的显示与隐藏

      parameter: { ...parameter }, // 添加成员请求参数

      query: { ...query }, // 获取用户下拉列表的请求参数

      userList: [], // 用户列表

      memberList: [], // 所有成员列表
      selectedMember: [] // 已选中的成员列表
    }
  },
  methods: {
    /**
     * API 获取用户下拉列表
     * @param {Boolean} reset 是否重置分页
     */
    async getUserOptions(reset = true) {
      try {
        if (reset) {
          this.query.pageNumber = 1
        }
        let { data } = await API.getUserOptions(this.query)
        this.userList = data.list
        this.memberList = data.list ? [...data.list.map((user) => user.showName)] : []
      } catch (error) {
        throw new Error(error.message)
      }
    },

    /**
     * API 为角色添加成员
     */
    async addRoleMember() {
      this.parameter.userIds = []
      this.selectedMember.forEach((selectedEmail) => {
        this.userList.forEach((userInfo) => {
          if (selectedEmail === userInfo.showName) {
            this.parameter.userIds.push(userInfo.userId)
          }
        })
      })
      let { code, message } = await API.addRoleMember(this.parameter)
      if (code === 10000) {
        this.close()
        this.$emit('update')
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 移除某个成员
     * @param {String} member 被移除的成员
     */
    closeMemberTag(member) {
      this.selectedMember.splice(this.selectedMember.indexOf(member), 1)
    },

    /**
     * 显示对话框
     * @param {Object} payload
     */
    show(payload) {
      this.visible = true
      this.parameter.roleId = payload.roleId
      this.getUserOptions()
    },

    /**
     * 保存按钮
     */
    save() {
      if (!this.selectedMember.length) {
        return this.$message.warning('请选择需要添加的成员!')
      }
      this.addRoleMember()
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据的方法
     */
    clear() {
      this.parameter = { ...parameter }
      this.query = { ...query }
      this.userList = []
      this.memberList = []
      this.selectedMember = []
    }
  }
}
</script>

<style lang="scss" scoped>
.member-container {
  display: flex;
  min-height: 380px;
  max-height: 580px;
  border: 1px solid #cdd4dd;
  border-radius: 4px;

  .member-list,
  .selected-member {
    padding: 15px;
  }

  .member-list {
    width: 298px;
    border-right: 1px solid #cdd4dd;

    .el-input {
      /deep/.el-input__inner {
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
      }
      /deep/.el-input-group__append {
        border-top-right-radius: 18px !important;
        border-bottom-right-radius: 18px !important;
      }
    }

    .member-item {
      height: calc(100% - 38px);
      margin-top: 15px;
      overflow-y: auto;
      .el-checkbox-group {
        display: flex;
        flex-direction: column;
        .el-checkbox {
          margin-right: 0;
          margin-bottom: 8px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .selected-member {
    flex: 1;
    .selected-tips {
      height: 38px;
      line-height: 38px;
      span {
        color: #99c41c;
        font-weight: 700;
      }
    }
    .selected-member-item {
      height: calc(100% - 38px);
      margin-top: 15px;
      overflow-y: auto;
      .el-tag {
        margin-right: 15px;
        margin-bottom: 15px;
      }
    }
  }
}
</style>
